import axiosClient from "@/libs/axiosClient";

export const checkDocumentExist = options => {
    return axiosClient.get(
        `/validate/documentexist?topic=${options.topic}&fieldVal=${
            options.fieldVal
        }&groupName=${options.groupName}&t=${new Date().getTime()}`
    );
};



// WEBPACK FOOTER //
// ./src/api/documentexist.js